/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 *     Import
 *     - Images
 */
import { DropdownArrowIcon } from '../../../../images/icons/DropdownArrow/DropdownArrow'
import { ViewIcon } from '../../../../images/icons/View/View'
import { EditIcon } from '../../../../images/icons/Edit/Edit'

/**
 * Each Policies row from the ClientsTable component
 *
 * @export
 * @class ClientsRowQuotes
 * @extends {React.Component<any, any>}
 */
export default class ClientsRowQuotes extends React.Component<any, any> {
    render() {
        return (
            <div
                className={`table__row table__row__vertical-line
                ${(this.props.quote.subjectivity) ? 'subjectivity-warning' : ''}`}
                onClick={(event) => { this.props.action(event) }}
            >
                <div className="column__dropdown">
                    <DropdownArrowIcon color={'#5174AE'} />
                </div>
                <div className="column">{this.props.quote.clientName}</div>
                <div className="column">{this.props.quote.inceptionDate}</div>
                <div className="column">{this.props.quote.quotedDate}</div>
                <div className="column">{this.props.quote.daysValid} days</div>
                <div className="column center">
                    <div>
                        <Link to={`/clients/quotes/view/${this.props.quote.id}`}>
                            <ViewIcon />
                        </Link>
                    </div>
                    <div onClick={() => this.props.openPopUp(this.props.quote.id)}>
                            <EditIcon />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/components/ClientsRowQuotes.tsx